import {
  approveAllReportedMymesAPI,
  approveSingleMymeReportAPI,
  deleteMymeAPI,
  GETReportedMymeDetails,
  getReportedMymeDetailsAPI
} from '@myme/api';
import { sendRequest, UUID } from '@myme/utils';

const getMymeIdRecord = (mymeId: UUID) => ({
  key: 'mymeId',
  value: mymeId
});

// TODO: to be removed when backend fixes its stuff
const getMymeIdRecord2 = (mymeId: UUID) => ({
  key: 'mymeId',
  value: mymeId
});

const getUserReportIdRecord = (userReportId: UUID) => ({
  key: 'userReportId',
  value: userReportId
});

/* **** DELETE **** /admin/mymes/:mymeId */
export const deleteReportedMyme = async (mymeId: UUID) =>
  sendRequest<null, null>(deleteMymeAPI, { args: [getMymeIdRecord(mymeId)] });

/* **** PATCH **** /admin/mymes/:mymeId */
export const approveReportedMyme = async (mymeId: UUID, userReportId: UUID) =>
  sendRequest<null, null>(approveSingleMymeReportAPI, {
    args: [getMymeIdRecord(mymeId), getUserReportIdRecord(userReportId)]
  });

/* **** PATCH **** /admin/mymes/approve-reports */
export const approveAllReportedMymes = async (mymeId: UUID) =>
  sendRequest<null, null>(approveAllReportedMymesAPI, { args: [getMymeIdRecord(mymeId)] });

/* **** GET **** /admin/mymes/:mymeId/details */
export const getReportedMymeDetails = async (mymeId: UUID) =>
  sendRequest<GETReportedMymeDetails, null>(getReportedMymeDetailsAPI, { args: [getMymeIdRecord2(mymeId)] });
